import { useMutation } from '@apollo/client';
import { RETRY_SCORING_BATCH } from '@gql/scoring';
import { TriggerScoringResult } from '../types';

export const useRetryScoringBatch = () => {
    const [mutate, { loading, error }] = useMutation<
        { retryScoringBatch: TriggerScoringResult },
        { batchId: string }
    >(RETRY_SCORING_BATCH);

    const retryScoringBatch = async (batchId: string): Promise<TriggerScoringResult | null> => {
        try {
            const { data } = await mutate({ variables: { batchId } });
            return data?.retryScoringBatch ?? null;
        } catch {
            return null;
        }
    };

    return { retryScoringBatch, loading, error };
};
